<template>
  <ion-app class="dark">
    <ion-split-pane when="sm" content-id="main">
      <side-menu />
      <ion-router-outlet id="main" />
    </ion-split-pane>
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, IonSplitPane } from '@ionic/vue';
import { defineComponent } from 'vue';
import SideMenu from '@/views/SideMenu.vue';

export default defineComponent({
    name: 'App',
    components: {
        IonApp,
        IonRouterOutlet,
        SideMenu,
        IonSplitPane,
    },

    mounted() {
        this.$store.watch(
            (_, getters) => getters['deviceTheme/isDarkTheme'],
            x => document.body.classList.toggle('dark', x),
            { immediate: true }
        );
    },
});
</script>